import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { DirectivesModule } from './../directives/directives.module';

import { IonicModule } from '@ionic/angular';

import { ShopOrderPage } from './shop-order.page';
import { BrMaskerModule } from 'br-mask';

const routes: Routes = [
  {
    path: '',
    component: ShopOrderPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    BrMaskerModule,
    DirectivesModule,
    RouterModule.forChild(routes)
  ],
  declarations: [ShopOrderPage]
})
export class ShopOrderPageModule {}
